import React, { Component } from 'react';
import { Link } from 'react-router';
import { Card, Col, Divider, Icon, Row, Table } from 'antd';

import { queryAdjustmentWorkflow, queryBudgetAnalysis } from '@api/finance/budget';

import moment from 'moment';
import util from '@util/index';
import Comment from '@comm/comment/Index';
import Process from '@comm/workflow/Process';
import DescriptionList from '@comm/DescriptionList';
import ProcessHistory from '@comm/workflow/ProcessHistory';
import { queryDictExpend } from '@api/core/dict';

const { Description } = DescriptionList;

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      details: [],
      records: [],
      minRecords: [],
      instance: {},
      histories: [],
      expendType: [],
      monthList: [],
      adjustList: [],
      incomeData: {},
      expendData: {},
      isSpread: false,
    };
  }

  componentWillMount() {}

  async componentDidMount() {
    // 获取数据
    const { data } = this.props;

    this.setState({
      data,
      records: data.records,
      details: data.details,
      instance: data.instance,
      histories: data.histories,
    });

    // 设置支出类别
    await queryDictExpend().then(res => {
      if (res.statusCode === 200) {
        this.setState({
          expendType: res.data,
        });
      }
    });

    // 设置月份数组
    const monthList = [
      { key: '一月', value: '01', disFlag: false },
      { key: '二月', value: '02', disFlag: false },
      { key: '三月', value: '03', disFlag: false },
      { key: '四月', value: '04', disFlag: false },
      { key: '五月', value: '05', disFlag: false },
      { key: '六月', value: '06', disFlag: false },
      { key: '七月', value: '07', disFlag: false },
      { key: '八月', value: '08', disFlag: false },
      { key: '九月', value: '09', disFlag: false },
      { key: '十月', value: '10', disFlag: false },
      { key: '十一月', value: '11', disFlag: false },
      { key: '十二月', value: '12', disFlag: false },
    ];

    // 设置调整类型
    const adjustList = [
      { key: '增加预算', value: 1 },
      { key: '减少预算', value: 0 },
    ];

    this.setState({
      monthList,
      adjustList,
    });

    queryAdjustmentWorkflow().then(res => {
      if (res.statusCode === 200) {
        const instanceBak = {};
        this.setState(() => {
          instanceBak.activities = res.data;
          return {
            instanceBak,
          };
        });
      }
    });
    this.setDR();
    this.getAnalysis();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.params.uuid !== this.props.params.uuid) {
      window.location.reload();
    }
  }

  // 设置details和records
  setDR = () => {
    const { details, records, expendType, monthList, adjustList } = this.state;
    const minRecords = [];
    let yearAdjustment = 0;
    const lengthh = records.length < 5 ? records.length : 5;

    details.map(item => {
      expendType.map(it => {
        if (it.value === item.type) {
          item.type = it.key;
        }
        return 1;
      });

      monthList.map(it => {
        if (it.value === item.month) {
          item.month = it.key;
        }
        return 1;
      });

      adjustList.map(it => {
        if (+it.value === item.target) {
          item.target = it.key;
        }
        return 1;
      });

      return 1;
    });

    records.map(item => {
      yearAdjustment += +item.adjustment;
      item.createTime = moment.unix(item.createTime / 1000).format('YYYY-MM-DD');
      expendType.map(it => {
        if (it.value === item.type) {
          item.type = it.key;
        }
        return 1;
      });

      monthList.map(it => {
        if (it.value === item.month) {
          item.month = it.key;
        }
        return 1;
      });

      adjustList.map(it => {
        if (+it.value === item.target) {
          item.target = it.key;
        }
        return 1;
      });

      return 1;
    });

    for (let i = 0; i < lengthh; i++) {
      minRecords.push(records[i]);
    }

    this.setState({
      details,
      records,
      minRecords,
      yearAdjustment,
    });
  };

  toPage = record => {
    this.props.router.push({
      pathname: `/finance/budget/${record.uuid}/${record.year}/adjust/info`,
    });
  };

  // 获取收支数据
  getAnalysis = () => {
    const params = {};
    let nowAimPre = 0;
    const { year } = this.props.params;
    const yStart = new Date(+year, 0, 1, 0, 0, 0, 0);
    const yEnd = new Date(+year + 1, 0, 1, 0, 0, 0, 0);
    const yNow = Date.now();

    if (yNow <= yStart) {
      nowAimPre = 0;
    } else if (yNow >= yEnd) {
      nowAimPre = 1;
    } else {
      nowAimPre = Math.floor(((yNow - yStart) / (yEnd - yStart)) * 10000) / 10000;
    }
    params.groupUuids = [this.state.data.groupUuid];
    params.year = year;
    queryBudgetAnalysis(params).then(res => {
      if (res.statusCode === 200) {
        res.data.income.map(item => {
          if (item.type === 'sum') {
            item.plan = item.aim * nowAimPre;
            this.setState({
              incomeData: item,
              expendData: res.data.expenditure,
            });
          }
          return item;
        });
      }
    });
  };

  inExtra = () => {
    const { records, isSpread } = this.state;
    if (records.length > 5) {
      if (isSpread === false) {
        return (
          <Link onClick={this.changeIsSpread}>
            更多
            <Icon
              type="down"
              style={{
                fontSize: '10px',
                paddingLeft: '3px',
                position: 'relative',
                top: '-1px',
              }}
            />
          </Link>
        );
      }
      if (isSpread === true) {
        return (
          <Link onClick={this.changeIsSpread}>
            收起
            <Icon
              type="up"
              style={{
                fontSize: '10px',
                paddingLeft: '3px',
                position: 'relative',
                top: '-1px',
              }}
            />
          </Link>
        );
      }
      return null;
    }
    return null;
  };

  // 展开历史列表
  changeIsSpread = () => {
    const { isSpread } = this.state;
    this.setState({
      isSpread: !isSpread,
    });
  };

  // 表格
  columns = () => {
    return [
      {
        title: '资金类型',
        dataIndex: 'type',
        key: 'type',
        render: text => <span>{text}</span>,
      },
      {
        title: '月份',
        dataIndex: 'month',
        key: 'month',
        render: text => <span>{text}</span>,
      },
      {
        title: '预算类型',
        dataIndex: 'target',
        key: 'target',
        render: text => <span>{text}</span>,
      },
      {
        title: '调整金额',
        dataIndex: 'adjustment',
        key: 'adjustment',
        render: text => <span>{util.numberFormat(text, 2, '.', ',')}元</span>,
      },
      {
        title: '原因',
        dataIndex: 'reason',
        key: 'reason',
        render: text => <span>{text}</span>,
      },
    ];
  };

  recordsColumns = () => {
    return [
      {
        title: '流水编号',
        dataIndex: 'no',
        key: 'no',
        render: (text, record) => <Link onClick={() => this.toPage(record)}>{text}</Link>,
      },
      {
        title: '预算组名称',
        dataIndex: 'groupName',
        key: 'groupName',
      },
      {
        title: '预算年度',
        dataIndex: 'year',
        key: 'year',
      },
      {
        title: '预算调整金额',
        dataIndex: 'adjustment',
        key: 'adjustment',
        render: (text, record) => {
          return <span>{text ? util.numberFormat(text, 2, '.', ',') : '-'}</span>;
        },
      },
      {
        title: '申请人',
        dataIndex: 'createUserName',
        key: 'createUserName',
        render: (text, record) => {
          return <span>{text || '-'}</span>;
        },
      },
      {
        title: '申请时间',
        dataIndex: 'createTime',
        key: 'createTime',
        render: (text, record) => {
          return <span>{text}</span>;
        },
      },
    ];
  };

  render() {
    const {
      data,
      records,
      minRecords,
      details,
      instance,
      histories,
      isSpread,
      incomeData,
      expendData,
      yearAdjustment,
    } = this.state;

    return (
      <div>
        <Card
          title="预算信息"
          extra={
            <div>
              <Link
                to={{
                  pathname: `/finance/budgets/${data.groupUuid}/year`,
                  query: {
                    companyName: data.groupName,
                  },
                }}
                style={{ marginRight: '10px' }}
              >
                查看预算统计
              </Link>
              <Link
                to={{
                  pathname: `/finance/budget/${data.groupUuid}/${data.year}/balance`,
                  query: {
                    source: 'all',
                  },
                }}
              >
                查看收支分析
              </Link>
            </div>
          }
        >
          <DescriptionList size="large" col={3}>
            <Description term="预算组">{data.groupName}</Description>
            <Description term="全年目标收入">{util.numberFormat(+incomeData.aim)}</Description>
            <Description term="全年预算支出">{util.numberFormat(+expendData.budget)}</Description>
            <Description term="预算总额">
              <span>
                {util.numberFormat(+data.budget)}
                {data.adjustment && data.instance.status === 0 ? (
                  <span style={{ color: 'red' }}>
                    <span style={{ color: '#505659' }}>{'( '}</span>
                    调整后：
                    {util.numberFormat(+data.adjustment + +data.budget)}
                    <span style={{ color: '#505659' }}>{' )'}</span>
                  </span>
                ) : (
                  ''
                )}
              </span>
            </Description>
            {/* <Description term="目标收入">
              {util.numberFormat(+data.aims)}
            </Description> */}
            <Description term="当前计划实现收入">{util.numberFormat(+incomeData.plan)}</Description>
            <Description term="当前实际使用预算">
              {util.numberFormat(+expendData.actual)}
            </Description>
            <Description term="预算年度">{data.year}</Description>
            <Description term="当前实际实现收入">
              {util.numberFormat(+incomeData.actual)}
            </Description>
            <Description term="本期预算余额">
              <span>
                {util.numberFormat(+data.current)}
                {data.freeze ? (
                  <span style={{ color: '#BCBCBC' }}>
                    <span style={{ color: '#505659' }}>{'( '}</span>
                    冻结
                    {util.numberFormat(+data.freeze)}
                    <span style={{ color: '#505659' }}>{' )'}</span>
                  </span>
                ) : (
                  ''
                )}
              </span>
            </Description>
            {/* <Description term="实际收入">
              {util.numberFormat(+data.income)}
            </Description> */}
          </DescriptionList>
          <Divider />
          <div style={{ textAlign: 'center', padding: '30px 0' }}>预算调整明细</div>
          <Table
            columns={this.columns()}
            dataSource={details}
            pagination={false}
            rowKey={record => record.uuid}
          />
          <div style={{ textAlign: 'center', padding: '30px 0' }}>
            {+yearAdjustment < 0 ? (
              <span style={{ color: 'red', paddingRight: '10px' }}>
                {data.groupName}本年度减少预算金额：
                {util.numberFormat(Math.abs(+yearAdjustment))}元
              </span>
            ) : (
              <span style={{ color: 'red', paddingRight: '10px' }}>
                {data.groupName}本年度增加预算金额：
                {util.numberFormat(+yearAdjustment)}元
              </span>
            )}
            {this.inExtra()}
          </div>
          <Table
            columns={this.recordsColumns()}
            dataSource={isSpread ? records : minRecords}
            pagination={false}
            rowKey={record => record.uuid}
          />
        </Card>
        <Card title="流程跟踪">
          <Row justify="center">
            <Col span={24} style={{ marginBottom: '16px', fontSize: '14px' }}>
              <div style={{ marginBottom: '16px', fontSize: '14px' }}>流程路径：</div>
              {instance ? <Process instance={instance} /> : null}
              {!instance && this.state.instanceBak ? (
                <Process instance={this.state.instanceBak} />
              ) : null}
            </Col>
            <Col span={24}>{histories ? <ProcessHistory dataSource={histories} /> : null}</Col>
          </Row>
        </Card>

        <Comment target={{ type: 'budgetAdjust', uuid: data.uuid }} />
      </div>
    );
  }
}

export default BaseForm;



// WEBPACK FOOTER //
// ./src/components/finance/budget/adjust/PageDetails.js